// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingView__loading--3uFhj"};